import { useCallback } from 'react'

export function useGetTopOfElementById() {
  const getTopOfElementById = useCallback(id => {
    const element = document.getElementById(id)
    const offsetTop = element?.offsetTop
    const scrollTop = document?.documentElement.scrollTop
    return offsetTop - scrollTop - 200
  }, [])

  return {
    getTopOfElementById,
  }
}
